import './App.css';

import FeaturedResults from './components/FeaturedResults';
import StudyMethod from './components/StudyMethod';
import Financing from './components/Financing';
import FloatingSidebar from './components/FloatingSidebar';
import VideoTrailer from './components/VideoTrailer';
// import Trailer from './components/Trailer';

import Navbar from './components/NavBar';
import Header from './components/Header';
import HeaderForm from './components/HeaderForm';
import Master from './components/Master';
import NewStudyMethod from './components/NewStudyMethod';
import Gallery from './components/Gallery';
import Plans from './components/Plans';
import Counseling from './components/Counseling';
import FAQ from './components/FAQ';
import FooterNew from './components/FooterNew';

function App() {
	return (
		<div className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Header />
			<HeaderForm />
			{/* <VideoTrailer /> */}
			<Master />
			{/* <Trailer /> */}
			<NewStudyMethod />
			<Gallery />
			<Plans />
			{/* <Financing /> */}
			<Counseling />
			{/* <FeaturedResults /> */}
			<FAQ />
			<FooterNew />
		</div>
	);
}

export default App;
